import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * Modal to add or edit the day summary (title + plain text). Renders below spanned accommodation and above activities.
 */
export default function DaySummaryModal({ show, onHide, dayLabel, initialSummaryTitle = '', initialSummary = '', onSave }) {
  const { t } = useTranslation();
  const [summaryTitle, setSummaryTitle] = useState(initialSummaryTitle);
  const [summary, setSummary] = useState(initialSummary);

  useEffect(() => {
    if (show) {
      setSummaryTitle(initialSummaryTitle || '');
      setSummary(initialSummary || '');
    }
  }, [show, initialSummaryTitle, initialSummary]);

  const handleSave = () => {
    const title = (summaryTitle || '').trim();
    const text = (summary || '').trim();
    if (onSave) onSave({ summaryTitle: title, summary: text });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('planDetail.days.daySummary.title', { defaultValue: 'Day summary' })} {dayLabel && `– ${dayLabel}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Control
            type="text"
            value={summaryTitle}
            onChange={(e) => setSummaryTitle(e.target.value)}
            placeholder={t('planDetail.days.daySummary.summaryTitlePlaceholder', { defaultValue: 'Title' })}
          />
        </Form.Group>
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={4}
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            placeholder={t('planDetail.days.daySummary.placeholder', { defaultValue: 'Add a short summary for this day…' })}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('common.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {t('planDetail.days.daySummary.save', { defaultValue: 'Save' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
